import PageTitle from "../../components/common/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../hooks/StoreHooks";
import { useEffect, useState } from "react";
import { EmployeesWrapper } from "./Employees.styles";
import { useProcessingRequest, useResponseValue } from "../../store/selectors/tableManagementSelector";
import { CircularIndeterminate } from "../../components/common/CircularIndeterminate";
import { setResponseValue } from "../../store/reducers/tableManagementReducer";
import { useServerSidePagination } from "../../hooks/PaginationHooks";
import EmployeesSearchBar from "./EmployeesSearchBar";
import EmployeesTable from "./EmployeesTable/EmployeesTable";
import { fetchPaginatedEmployeesThunk } from "../../store/thunk/employeesThunk";
import { useGroupsData } from "../../store/selectors/groupSelectors";
import { fetchGroupsThunk } from "../../store/thunk/groupsThunk";
import { EmployeeUserType } from "../../types/employeeType";
import { fetchSubCompaniesThunk } from "../../store/thunk/subCompaniesThunk";
import CreateOrEditEmployeeDialog from "./EmployeesTable/CreateOrEditEmployeeDialog";
import { fetchServiceModulesThunk } from "../../store/thunk/serviceModulesThunk";
import {GroupItem} from "../../types/groupItem";

const Employees = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const processingRequest = useProcessingRequest()
  const responseValue = useResponseValue()
  const groupList = useGroupsData();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState<GroupItem[]>([]);

  useEffect(() => {
    dispatch(fetchGroupsThunk());
    dispatch(fetchSubCompaniesThunk());
    dispatch(fetchServiceModulesThunk());
  }, [dispatch]);

  const paginatedData = useServerSidePagination<EmployeeUserType>(
    async (paginationParameters) => {
      const resultAction = await dispatch(fetchPaginatedEmployeesThunk({
          paginationParams: paginationParameters,
          groupIds: selectedGroups.map(g => g.id)
      }));

      if (fetchPaginatedEmployeesThunk.fulfilled.match(resultAction)) {
        return resultAction.payload;
      } else {
        return { items: [], totalCount: 0 };
      }
    },
    []
  );

  useEffect(() => {
    if (responseValue.includes("fulfilled")) {
      paginatedData.updateTableItems();
      dispatch(setResponseValue(""))
    }
  }, [dispatch, paginatedData, responseValue]);

  return (
    <>
      <PageTitle
        title={t("employeesPage.title")}
      />
      <EmployeesWrapper>
        <EmployeesSearchBar
          handleOnSearch={paginatedData.handleOnSearch}
          onCreateEmployee={() => setOpenCreateModal(true)}
          groups={groupList}
          selectedGroups={selectedGroups}
          onSelectGroups={(groups) => {
              setSelectedGroups(groups);
              paginatedData.updateTableItems();
          }}
        />
        <EmployeesTable
          data={paginatedData}
          groupList={groupList}
        />
      </EmployeesWrapper>

      {openCreateModal && <CreateOrEditEmployeeDialog
        open={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        groupList={groupList}
        mode="create"
      />}
      <CircularIndeterminate processingRequest={processingRequest} />
    </>
  );
};

export default Employees;
